import messages from './messages.js';

export const USERNAME_PATTERN = '^[^@\\s][^@]{4,98}[^@\\s]$';
export const USERNAME_MESSAGE = messages.pattern;

export const EXTERNAL_PROVIDERS = {
  1: { label: 'Google', icon: 'ss-google' },
  2: { label: 'Microsoft', icon: 'ss-windows8' },
  3: { label: 'Apple', icon: 'ss-appleinc' },
};
